import React from 'react';
import Menu from '../Menu';
import { menuLinks, sections, bestPracticesDefault } from './../constants'
import ils_15 from './../images/assets/ils_15.svg';
import ServiceContent from './ServiceContent';

const title = sections.services.predictiveAnalytics.page.title
const description = 'Transform time series data into intelligent business decisions with agentic predictive systems. We combine state-of-the-art forecasting models with autonomous agents that monitor, analyze, and respond to data patterns in real-time. Our solutions go beyond prediction—they create self-healing pipelines that automatically detect anomalies, generate insights, and trigger intelligent responses. From demand forecasting to automated data transformations, our agentic workflows ensure your business stays ahead of trends.'

const useCases = [
	'Multi-agent collaborative forecasting systems for complex demand patterns',
	'Sales and demand forecasting with automatic seasonality detection',
	'Inventory optimization with intelligent reorder agents',
	'Automated insight generation and business intelligence reporting',
	'Self-healing data pipelines with agent-based monitoring',
	'Intelligent alert systems with context-aware responses',
	'Real-time anomaly detection with automated root cause analysis',
	'Predictive maintenance with autonomous monitoring agents'
]
const bestPractices = bestPracticesDefault.concat([
	'Online learning for real-time model adaptation',
	'Multi-agent orchestration for complex forecasting scenarios',
	'Automated model retraining based on performance metrics',
	'Agentic monitoring systems for continuous data quality checks',
	'Intelligent alerting with contextual business insights'
])

const faqs = [
	{
		question: "What is agentic forecasting and how is it different from traditional predictive analytics?",
		answer: "Agentic forecasting uses autonomous AI agents that go beyond generating predictions. These agents continuously monitor data patterns, automatically detect anomalies, generate business insights, and trigger intelligent responses. Unlike traditional forecasting that produces static predictions, agentic systems create self-healing pipelines that adapt to changing conditions in real-time."
	},
	{
		question: "How does AI handle seasonality in demand forecasting?",
		answer: "AI-powered demand forecasting automatically detects multiple seasonal patterns (weekly, monthly, yearly) in historical data using techniques like Fourier analysis and decomposition. CaptainMe AI builds models that account for overlapping seasonal effects, holiday impacts, and trend changes to produce accurate forecasts even with complex seasonal patterns."
	}
]

function ServicePredictiveAnalytics() {
	return (
		<React.Fragment>
			< Menu />

			<ServiceContent
				pageTitle='Predictive Analytics & Agentic Forecasting'
				title={title}
				description={description}
				useCases={useCases}
				bestPractices={bestPractices}
				img={ils_15}
				breadCrumpMenu={sections.services.predictiveAnalytics.title}
				currentMenuPage={menuLinks.servicesPredictiveAnalytics}
				faqs={faqs}
			/>

		</React.Fragment>
	)
}

export default ServicePredictiveAnalytics;
